import React, { Component } from "react";
import { healthTipService } from '../services/healthTip';
import '../assets/styles/ExpertColumn.scss';
import _ from 'lodash';
import Spinner from 'react-bootstrap/Spinner';
import SEO from './SEO';

class ExpertColumnDetail extends Component {

    constructor(props){
        super(props);

        this.state = {
            loading: false,
            expert_column: {},
            metadata: {
                title: 'Health Tips - Expert Column',
                description: 'Health-related article by professionals from the healthcare industry.',
                type: 'website'
            }
        }
    }

    getExpertColumn(id){
        this.setState({ loading: true });
        healthTipService.getHealthTipDetail(id).then(
            res => {
                if(res){
                    this.setState(prevState => ({
                        expert_column: res,
                        metadata: {
                            ...prevState.metadata,
                            title: `${res.title}`,
                            description: `${res.short_description}`,
                            image: res.image.cover
                        }
                    }))
                }
            },
            error => {
                console.log('There has been a problem with your fetch operation: ', error.message);
            }
        ).then(() => {
            this.setState({ loading: false });
        });
    }

    componentDidMount(){
        if(this.props.match.params.id){
            this.getExpertColumn(this.props.match.params.id);
        }
    }

    render() {
        return (
            <div className="expert-column-detail-page container">
                <SEO 
                title={this.state.metadata.title} 
                description={this.state.metadata.description}
                type={this.state.metadata.type}
                image={this.state.metadata.image} />
                <div className="header">
                    <div className="title">Expert Columns</div>
                    <div className="bread-crumb">Home / <a className="header-anchor" href="/search-book/expert-column">Expert Columns</a> / {this.state.expert_column ? this.state.expert_column.title : '-'}</div>
                </div>
                <hr className="header-line"/>
                <div className="body">
                    {(() => {
                        if (this.state.loading) {
                            return <div className="loader"><Spinner animation="border" className="spinner"/></div>;
                        } else {
                            return (_.isEmpty(this.state.expert_column) ? <div className="empty-div">Article Not Found</div> : (
                                <div className="details-div">
                                    <div className="image"><img src={this.state.expert_column.image.origin} alt='expert-column-img'/></div>
                                    <div className="author-date">
                                        {this.state.expert_column.author} . {this.state.expert_column.publish_date}
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: this.state.expert_column.content }}></div>
                                </div>
                            ));
                        }
                    })()}
                </div>
            </div>

        );
    }
}

export { ExpertColumnDetail };
